import { SaveExistingFirebaseCredentials } from 'modules/webPush/WebPushV2/components/Modals/components';
import {
  JSON_CREDENTIALS_HELP_TEXT,
  JSON_CREDENTIALS_LABEL,
} from 'modules/webPush/WebPushV2/constants';
import {
  useWebPushFormContext,
  useWebPushMetadataContext,
} from 'modules/webPush/WebPushV2/context';
import { getFormErrorMessages } from 'modules/webPush/WebPushV2/utils';
import { ErrorCode, FileRejection } from 'react-dropzone';
import { FileDropzone } from 'ui/fileDropzone';
import { FormField } from 'ui/formField';
import { BasicInputField } from './BasicInputField';

export const FIREBASE_WEB_PUSH_INTEGRATION_FORM_ID = 'firebase-web-push-integration-form';

export const FirebaseIntegrationForm = () => {
  const { integration } = useWebPushMetadataContext();
  const { clearErrors, formState, setError, setValue } = useWebPushFormContext();

  const { fcmSenderId: senderErrorText, firebaseJsonFile: fileErrorText } = getFormErrorMessages(
    formState.errors,
  );

  const setFileError = (rejection: FileRejection | undefined) => {
    if (rejection === undefined) return clearErrors('firebaseJsonFile');

    const invalidTypeError = rejection.errors.find((e) => e.code === ErrorCode.FileInvalidType);
    if (invalidTypeError)
      setError('firebaseJsonFile', { message: 'Unsupported file type', type: 'validate' });
  };

  const handleCancel = () => {
    clearErrors('firebaseJsonFile');
  };

  const handleUpload = (acceptedFiles: File[], fileRejections?: FileRejection[]) => {
    setValue('firebaseJsonFile', acceptedFiles[0]);
    setFileError(fileRejections?.[0]);
  };

  return (
    <>
      <FormField
        data-test={`${FIREBASE_WEB_PUSH_INTEGRATION_FORM_ID}-file-dropzone-field`}
        errorText={fileErrorText}
        hasError={!!fileErrorText}
        helpText={!fileErrorText && JSON_CREDENTIALS_HELP_TEXT}
        labelText={JSON_CREDENTIALS_LABEL}
      >
        <FileDropzone
          accept={{ 'application/json': ['.json'] }}
          onCancel={handleCancel}
          onUpload={handleUpload}
        />
      </FormField>
      <BasicInputField
        data-test={`${FIREBASE_WEB_PUSH_INTEGRATION_FORM_ID}-sender-id-field`}
        errorText={senderErrorText}
        helpText={
          'This can be found in your Firebase console under the Cloud Messaging tab in Project Settings.'
        }
        labelText={'Sender ID'}
        name="fcmSenderId"
      />
      {integration?.fcmServerKey && (
        <SaveExistingFirebaseCredentials
          data-test={`${FIREBASE_WEB_PUSH_INTEGRATION_FORM_ID}-save-existing-credentials-section`}
          fcmSenderId={integration.fcmSenderId}
          fcmServerKey={integration.fcmServerKey}
        />
      )}
    </>
  );
};
